"use client";

import { createContext, useContext } from "react";
import type { HomeContent } from "@/lib/content/home";
import type { FaqContent } from "@/lib/content/faq";
import type { NavigationContent } from "@/lib/content/navigation";

const NavigationContentContext = createContext<NavigationContent | null>(null);
const HomeContentContext = createContext<HomeContent | null>(null);
const FaqContentContext = createContext<FaqContent | null>(null);

export function NavigationContentProvider({
  content,
  children,
}: {
  content: NavigationContent;
  children: React.ReactNode;
}) {
  return (
    <NavigationContentContext.Provider value={content}>
      {children}
    </NavigationContentContext.Provider>
  );
}

export function HomeContentProvider({
  content,
  children,
}: {
  content: HomeContent;
  children: React.ReactNode;
}) {
  return (
    <HomeContentContext.Provider value={content}>
      {children}
    </HomeContentContext.Provider>
  );
}

export function FaqContentProvider({
  content,
  children,
}: {
  content: FaqContent;
  children: React.ReactNode;
}) {
  return (
    <FaqContentContext.Provider value={content}>{children}</FaqContentContext.Provider>
  );
}

export function useNavigationContent(): NavigationContent {
  const content = useContext(NavigationContentContext);

  if (!content) {
    throw new Error(
      "useNavigationContent must be used within NavigationContentProvider",
    );
  }

  return content;
}

export function useHomeContent(): HomeContent {
  const content = useContext(HomeContentContext);

  if (!content) {
    throw new Error("useHomeContent must be used within HomeContentProvider");
  }

  return content;
}

export function useFaqContent(): FaqContent {
  const content = useContext(FaqContentContext);

  if (!content) {
    throw new Error("useFaqContent must be used within FaqContentProvider");
  }

  return content;
}
